import { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Flex,
  Icon,
  SimpleGrid,
  useColorModeValue
} from '@chakra-ui/react';
import Statistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';
import { useDashboard } from 'contexts/DashboardContext';
import { FaLocationDot } from 'react-icons/fa6';
import { FiUsers } from "react-icons/fi";
import { useSocket } from '../../socket';

export default function Dashboard() {
  const [locations, setLocations] = useState([]);
  const [totalLiveMembers, setTotalLiveMembers] = useState(0);
  const [totalActiveMembers, setTotalActiveMembers] = useState(0);
  const [totalInactiveMembers, setTotalInactiveMembers] = useState(0);
  const [totalRegisteredMembers, setTotalRegisteredMembers] = useState(0);
  const [totalAccessEnabledMembers, setTotalAccessEnabledMembers] = useState(0);

  const brandColor = useColorModeValue('brand.500', 'white');
  const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

  const { getActiveMembersInLocation, getMemberStatus } = useDashboard();
  const socket = useSocket();

  const fetchMemberStats = async ()=>{
    try {
      const data = await getMemberStatus();
      if (data) {
        setTotalActiveMembers(data.totalActiveMembers);
        setTotalInactiveMembers(data.totalInactiveMembers);
        setTotalRegisteredMembers(data.totalRegisteredMembers);
        setTotalAccessEnabledMembers(data.totalAccessEnabledMembers);
      }
    } catch (error) {
      console.error("Failed to fetch Dashboard data:", error);
    }
  }

  const fetchLocationUsers = async () => {
    try {
      const data = await getActiveMembersInLocation();
      if (data) {
        setTotalLiveMembers(data.totalActiveMembers);
        setLocations(data.locations);
      } else {
        console.warn("No location members found or data is undefined");
      }
    } catch (error) {
      console.error("Failed to fetch Dashboard data:", error);
    }
  }

  useEffect(() => {    
    socket.on('locationCapacityValidation', (data)=>{
      // console.log("socket data", data);
    });

    return () => {
      socket.off('locationCapacityValidation', fetchLocationUsers);
    };
  }, [socket]);

  useEffect(() => {
    fetchMemberStats()
    fetchLocationUsers();
  }, []);

  return (
    <Flex pt={{ base: '130px', md: '80px', xl: '55px' }}>
      <Flex direction="column" width="stretch" overflow="auto" minHeight="80vh">
      <SimpleGrid
          columns={{ sm: 1, md: 2, lg: 2, xl: 3, '2xl': 4 }}
          gap="20px"
          mb="20px"
        >
          <Flex>
            <Statistics
              bgGradient="linear(180deg, rgba(249,182,76,1) 0%, rgba(250,143,3,1) 33%)"
              title={'Registered Members'}
              value={totalRegisteredMembers}
              illustration={
                <IconBox
                  h="48px"
                  w="48px"
                  bg={boxBg}
                  icon={
                    <Icon color="black" as={FiUsers} w="30px" h="30px" />
                  }
                />
              }
            />
          </Flex>
          <Flex>
            <Statistics
              bgGradient="linear(180deg, rgba(249,182,76,1) 0%, rgba(250,143,3,1) 33%)"
              title={'Active Members'}
              value={totalActiveMembers}
              illustration={
                <IconBox
                  h="48px"
                  w="48px"
                  bg={boxBg}
                  icon={
                    <Icon color="black" as={FiUsers} w="30px" h="30px" />
                  }
                />
              }
            />
          </Flex>
          <Flex>
            <Statistics
              bgGradient="linear(180deg, rgba(249,182,76,1) 0%, rgba(250,143,3,1) 33%)"
              title={'Inactive Members'}
              value={totalInactiveMembers}
              illustration={
                <IconBox
                  h="48px"
                  w="48px"
                  bg={boxBg}
                  icon={
                    <Icon color="black" as={FiUsers} w="30px" h="30px" />
                  }
                />
              }
            />
          </Flex>
           <Flex>
            <Statistics
              bgGradient="linear(180deg, rgba(249,182,76,1) 0%, rgba(250,143,3,1) 33%)"
              title={'Active Members Memberships'}
              value={totalAccessEnabledMembers}
              illustration={
                <IconBox
                  h="48px"
                  w="48px"
                  bg={boxBg}
                  icon={
                    <Icon color="black" as={FiUsers} w="30px" h="30px" />
                  }
                />
              }
            />
          </Flex>
        </SimpleGrid>
        <SimpleGrid
          columns={{ sm: 1, md: 2, lg: 2, xl: 3, '2xl': 4 }}
          gap="20px"
          mb="20px"
        >
          <Flex>
            <Statistics
              bgGradient="linear(180deg, rgba(249,182,76,1) 0%, rgba(250,143,3,1) 33%)"
              title={'Live Members'}
              value={totalLiveMembers}
              illustration={
                <IconBox
                  h="48px"
                  w="48px"
                  bg={boxBg}
                  icon={
                    <Icon color="black" as={FiUsers} w="30px" h="30px" />
                  }
                />
              }
            />
          </Flex>
          {locations.length > 0 && locations.map((location, index) => {
            return (
              <Flex key={index}>
                <Statistics
                  bgGradient="linear(180deg, rgba(249,182,76,1) 0%, rgba(250,143,3,1) 33%)"
                  title={`${location.name} Live Members`}
                  value={location.active_members}
                  illustration={
                    <Avatar
                      h="48px"
                      w="48px"
                      bg="white"
                      color="black"
                      src={location.logo || undefined}
                      icon={<FaLocationDot />}
                    />
                  }
                />
              </Flex>
            );
          })}
        </SimpleGrid>
      </Flex>
    </Flex>
  );
}
